export default __webpack_public_path__ + "static/media/Cls2.37a8813c.png";